<template>
    <tr class="lms__superadmin_workspaces_edit_feedbackforms_table_item">
        <td class="lms__superadmin_workspaces_edit_feedbackforms_table_name">
            {{ feedbackFormName }}
        </td>
        <td v-if="false" class="lms__superadmin_workspaces_edit_feedbackforms_table_coursesusage">
            <component-text-list
                :items="feedbackFormCoursesUsage"
                :limit-active="true"
                :limit-items="1"
            ></component-text-list>
        </td>
        <td class="lms__superadmin_workspaces_edit_feedbackforms_table_updatedat">
            {{ feedbackFormUpdatedAtDate }}
            <component-text :size="'tiny'">
                Time: {{ feedbackFormUpdatedAtTime }}
            </component-text>
        </td>
        <td class="lms__superadmin_workspaces_edit_feedbackforms_table_status">
            <template v-if="feedbackFormDefault">
                <component-status :status="feedbackFormDefault"></component-status>
            </template>
        </td>
        <td class="lms__superadmin_workspaces_edit_feedbackforms_table_actions">
            <div class="columns">
                <div class="column"></div>
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-workspace-edit-feedback-forms-table-item-edit-action'"
                            :theme="'default'"
                            @click="performEmit('emit-edit', feedbackFormId !== 'default' ? feedbackFormId : 'default')"
                        >{{ feedbackFormId !== 'default' ? 'Edit' : 'View' }}
                        </component-button>
                    </div>
                <template v-if="buttonMenuList.length">
                    <div class="column is-narrow">
                        <component-button-menu
                            :buttons="buttonMenuList"
                            @emit-make-copy="performEmit('emit-make-copy', feedbackFormId || 'default')"
                            @emit-make-default="performEmit('emit-make-default', feedbackFormId)"
                            @emit-remove="performEmit('emit-remove', feedbackFormId)"
                        ></component-button-menu>
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>

import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime, toLocaleTime } from '@/functions'
import ComponentText from '@/components/default/shared/ComponentText'
import ComponentTextList from '@/components/default/shared/ComponentTextList'

export default {
  name: 'lms-superadmin-workspace-edit-feedback-forms-table-item',
  components: { ComponentTextList, ComponentText, ComponentButtonMenu, ComponentButton, ComponentStatus },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    feedbackFormName () {
      return this.item.name
    },
    feedbackFormUpdatedAtTime () {
      return toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.updatedAt || this.item.createdAt))
    },
    feedbackFormUpdatedAtDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.updatedAt || this.item.createdAt))
    },
    feedbackFormCoursesUsage () {
      return this.item.courses
    },
    feedbackFormId () {
      return this.item.id
    },
    feedbackFormDefault () {
      return this.item.default ? 'default' : ''
    },
    feedbackFormIsDefault () {
      return false
    },
    buttonMenuList () {
      let listArr = []

      listArr.push({
        key: 'make-copy',
        name: 'Make copy'
      })
      if (!this.feedbackFormDefault) {
        listArr.push({
          key: 'make-default',
          name: 'Make default'
        })
        if (this.feedbackFormId !== 'default') {
          listArr.push({
            key: 'remove',
            name: 'Remove'
          })
        }
      }

      return listArr
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message, value })
    }
  }
}
</script>
